import React from 'react';
import { MoreOutlined } from '@ant-design/icons';
import { Skeleton, Card, Divider } from 'antd';
import styled from 'styled-components/macro';

const SkeletonInput = styled(Skeleton.Input)<{ width?: string; height?: string }>`
    && {
        width: ${(props) => props.width || '120px'};
        height: ${(props) => props.height || '18px'};
    }
`;

const SkeletonButton = styled(Skeleton.Button)<{ width?: string; height?: string; borderRadius?: string }>`
    && {
        width: ${(props) => props.width || '100px'};
        height: ${(props) => props.height || '20px'};
        border-radius: ${(props) => props.borderRadius || '0px'};
    }
`;

const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    justify-content: space-between;
`;

const GlossaryTermSkeleton = () => {
    return (
        <>
            <Card className="pa-4">
                <HeaderContainer>
                    <SkeletonInput width="100px" height="18px" active />
                    <MoreOutlined style={{ fontSize: '16px', color: '#bfbfbf' }} />
                </HeaderContainer>

                <div className="mb-2">
                    <SkeletonInput width="250px" height="20px" className="mr-2" active />
                    <SkeletonButton active />
                </div>

                <div className="mb-2">
                    <SkeletonInput width="100px" height="18px" active />
                </div>

                <SkeletonButton width="50px" height="20px" borderRadius="16px" active />
            </Card>

            <Divider className="ma-0" />
        </>
    );
};

export default GlossaryTermSkeleton;
